import axios from 'axios';

export const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('dayflow-token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    try {
      const workspace = JSON.parse(localStorage.getItem('workspace-storage'));
      const workspaceId = workspace?.state?.activeWorkspaceId;
      if (workspaceId) config.headers['X-Workspace-Id'] = workspaceId;
    } catch (error) {
      // Un valor local inválido no debe impedir que salga la petición.
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original?._retry && !original?.url?.includes('/auth/refresh')) {
      original._retry = true;
      try {
        const { data } = await axios.post(`${API_BASE_URL}/auth/refresh`, {}, { withCredentials: true });
        localStorage.setItem('dayflow-token', data.token);
        original.headers.Authorization = `Bearer ${data.token}`;
        return api(original);
      } catch (refreshError) {
        localStorage.removeItem('dayflow-token');
        if (window.location.pathname !== '/login') window.location.assign('/login');
      }
    }
    if (typeof window !== 'undefined' && error.response?.status !== 401) {
      const message = error.response?.data?.message || error.response?.data?.error || 'No se pudo completar la acción.';
      window.dispatchEvent(new CustomEvent('dayflow-api-error', { detail: message }));
    }
    return Promise.reject(error);
  }
);

export default api;
